module.exports = __webpack_public_path__ + "img/d6642a86c4dc97e39b39991369ba4419.png";